export const setAutoLogoutTime = value =>
  sessionStorage.setItem('setAutoLogoutTime', value);
export const getAutoLogoutTime = () => {
  return sessionStorage.getItem('setAutoLogoutTime') || 900; // default 15 minutes
};

export default { setAutoLogoutTime, getAutoLogoutTime };
